<template>
  <div class="basket-desktop-layout" :class="{ _column: !showSidebar }">
    <div class="basket-desktop-layout__body">
      <div class="basket-desktop-layout__tabs-holder">
        <tabs-page
          class="basket-desktop-layout__tabs"
          :current-tab="currentTab"
          @changeTab="handleChange"
        />
        <change-all-items
          v-if="!isEmptyBasket && isBasket"
          class="basket-desktop-layout__change-all"
          :is-deleted-all="isDeletedAll"
          @changeAllItems="handlerChangeAll"
        />
      </div>
      <div class="basket-desktop-layout__content">
        <slot></slot>
      </div>
    </div>
    <div v-if="showSidebar" class="basket-desktop-layout__sidebar">
      <slot name="sidebar"></slot>
    </div>
  </div>
</template>

<script>
import { defineComponent } from '@vue/composition-api';
import LazyHydrate from 'vue-lazy-hydration';

import TabsPage from '@/components/TabsPage/index.vue';
import ChangeAllItems from '@/components/_desktop/LayoutPage/ChangeAllItems/index.vue';

import { BASKET_TAB_VALUE } from '@/enums';

export default defineComponent({
  name: 'LayoutPage',
  components: {
    LazyHydrate,
    TabsPage,
    ChangeAllItems,
  },
  props: {
    showSidebar: { type: Boolean, default: true },
    currentTab: { type: String, default: BASKET_TAB_VALUE },
    isDeletedAll: { type: Boolean, default: false },
    isEmptyBasket: { type: Boolean, default: false },
    isBasket: { type: Boolean, default: true },
    productsInShelf: { type: Array, default: () => ([]) },
    isLoadingProductsInShelf: { type: Boolean, default: false },
  },
  setup(props, { emit }) {
    const handleChange = (type) => {
      emit('changeTab', type);
    };

    const handlerChangeAll = () => {
      emit('changeAllItems');
    };

    const handlerAddToBasket = () => {
      emit('addToBasketInShelf');
    };

    return {
      handleChange,
      handlerChangeAll,
      handlerAddToBasket,
    };
  },
});
</script>

<style lang="less">
.basket-desktop-layout {
  display: grid;
  grid-template-columns: minmax(580px, 1480px) minmax(300px, 420px);
  grid-template-areas: "body sidebar";
  grid-column-gap: 60px;

  &._column {
    display: block;
  }

  &__sidebar {
    grid-area: sidebar;
  }

  &__body {
    grid-area: body;
  }

  &__tabs-holder {
    border-bottom: 1px solid @gray-super-light;
    display: flex;
    justify-content: space-between;
  }

  &__shelf {
    margin-top: 60px;
  }
}
</style>
